import { render, staticRenderFns } from "./EditHomeEhotelRightImg.vue?vue&type=template&id=2365bc96&scoped=true"
import script from "./EditHomeEhotelRightImg.vue?vue&type=script&lang=js"
export * from "./EditHomeEhotelRightImg.vue?vue&type=script&lang=js"
import style0 from "./EditHomeEhotelRightImg.vue?vue&type=style&index=0&id=2365bc96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365bc96",
  null
  
)

export default component.exports